import { Injectable } from '@angular/core';

import { delayWhen } from 'rxjs/operators';
import { ExamList } from './exam-selector/exam-list';


@Injectable({
  providedIn: 'root'
})
export class FixedDataService {
  examList: ExamList[];

  getDueDays(feature: string) {
    return 3;
  }

  boardList: Array<string>;
  headerId: number;
  title: string;
  btnMap: Map<string, Array<string>>;

  constructor() {
    // in future get from owner-board..
    this.boardList = ["CBSE", "ICSE", "NEET", "BSEB", "civil", "ee", "JEE", "UPSC", "GRE", "KCET","board","cmn"];
  }


  hdrGrpNeeded(type: string) {
    let type1 = type.replace("twip-", "");
    var hdrGroupFree = ['eps', 'uppr', 'pbstr', 'tigp', 'dps'];
    return !hdrGroupFree.includes(type1);
  }



  getTagHeading(offering: string): string {

    if (offering) {
      if (offering.includes('dhw')) { return 'Homework:' }
      if (offering.includes('pbstr')) { return 'Percentage Booster:' }
      if (offering.includes('ubstr')) { return 'Unit Booster:' }
      if (offering.includes('eps')) { return 'Question Paper:' }
      if (offering.includes('doc')) { return 'Available Docs:' }

    }
    /*
    if(offering){
      console.log("please setup heading for bldr-fixeddata : "+ offering  );
    }
    */
    return offering + ":-";
  }

  skipSingleListing(offering: string): boolean {

    let excludeList = []; // ['pbstr', 'mpb', 'cmtg', 'mtg', 'nws', 'rvw', 'car']

    return excludeList.includes(offering)
  }

  tagBased(offering: string): boolean {
    var tagBased: Array<string> = ['pbstr', 'tavl-pyq', 'dhw', 'mtg', 'dps', 'opt']
    return (offering  && (tagBased.includes(offering) || (offering.startsWith('t') && offering != 'type') ) );
  }


  //mainly tag based to create in tag only? like pbstr,dhw
  tagBasedForCreate(justOffering: string): boolean {
    var tagBased: Array<string> = ['pbstr', 'twip-pbstr', 'tasgn-pbstr', 'tstore-pbstr', 'dhw', 'twip-dhw', 'mtg', 'dps', 'opt', 'ubstr']
    return (justOffering &&justOffering !="type" &&  (justOffering.startsWith("t") || (tagBased.includes(justOffering))));
  }



  getCmntHeading(cmntType: string, groupId?: string): string {
    var heading = cmntType + " : setup heading in fixeddataServ-75";
    let cmntT = cmntType.substr(1);
    switch (cmntT) {
      case 'mtg':
        heading = "Meeting Details:"
        break;
      case 'clr':
        heading = "doubt"
        break;

      case 'ans':
        heading = "User's Answer"
        break;

      case 'info':
        heading = "Extra Info:"
        break;
      case 'qchat':
        heading = "ask doubt/leave feedback:";

        break;

      case 'crct':
        heading = "Overall feedback:"
        break;

      case 'cmnt':
        heading = "Feedback:"
        break;
      case 'tstmnl':
        heading = "Testimonial:"
        break;
      case 'home':
        heading = "Feedback";
        break;
      case 'rfc':
        heading = "feedback";
        break;
      case 'digErr':
        heading = "Digitization Error";
        break;
      case 'note':
        heading = "Teacher's Note";
        if (groupId == "learner") {
          heading = "Teacher's Note";
        } else {
          heading = "Teacher's Note";
        }
        break;
      case 'selfNote':
        heading = "just for my eyes ";
        break;
      default:
        if (cmntType.startsWith('H')) {
          heading = 'Feedback <i class="fa fa-handshake-o" aria-hidden="true"></i>'
        }

    }

    // alert(cmntType +" / " + heading);
    return heading;
    //throw new Error("Method not implemented.");
  }


  activeRec: any;

  getActiveRec() {
    if (!this.activeRec) {
      this.activeRec = this.getBtnDetail('chptrList', 'showNew', "")
    }
    return this.activeRec;
  }

  btnDetails: any;



  getBtnDetail(component: string, btnId: string, usrGrp: string) {
    
    // this done for eb-site_mngr kinda multi role
    let trimmedUsrGrp = usrGrp;
     if(usrGrp.includes("-") ){ trimmedUsrGrp= usrGrp.split("-")[1]}
     


    //console.log(this.btnDetails);
    if (this.btnDetails) {

      let bds = this.btnDetails.filter(d => { if ((d.section == component) && (d.groupId == btnId + "-" + trimmedUsrGrp)) { return true; } else { return false; } });

      if (!bds || !bds[0]) {
        bds = this.btnDetails.filter(d => { if ((d.section == component) && (d.groupId == btnId)) { return true; } else { return false; } });
      }

      //console.log(bds[0]);

      if (bds.length > 0) {
        return bds[0]
      }
    }
    else {
      //return bds[0]
      return null;
    }
  }


  loadBtnData(btnData: any) {
    this.loadBtnAuthMap(btnData.map);
    this.btnDetails = btnData.dataList;
  }


  fdBtnMap = new Map<string, Array<string>>();

  //coming from site constructor through updateBtnMap
  overrideBtnMap = new Map<string, Array<string>>();
  updatedBtnMap: boolean;

  loadBtnAuthMap(overrideMap?: any) {

    /*
    if(!(this.fdBtnMap.size>0)){
      console.log("fdBtnMap is empty");
    this.fdBtnMap = this.getFDBtnAuthMapDelete(); 
      console.log(this.fdBtnMap);
    }
  */

    if (overrideMap) {
      for (var key in overrideMap) {
        this.fdBtnMap.set(key, overrideMap[key]);
      }
      this.updatedBtnMap = true;
      //console.log(this.fdBtnMap);
    }else{
      //get from memory?

      
    }

    return this.fdBtnMap;

  }

  getFDBtnAuthMapDelete() {
    let btnMap = new Map<string, Array<string>>();
    btnMap.set("menu-search", ['PVT']);
    btnMap.set("menu-admin", ['ROLE_ADMIN']);
    btnMap.set("menu-selectExam", ['ROLE_ADMIN']);
    btnMap.set("qstnList-assign", ['crclm_mngr', 'TEACHER', 'LWP-PARENT']);
    //disabling for this year-20-21  as special case
    btnMap.set("qstnList-outOfSyl", ['PVT']);
    //btnMap.set("qstnList-outOfSyl",['TEACHER','crclm_mngr','ROLE_ADMIN']);
    btnMap.set("qstnList-changeInactive", ['TEACHER', 'crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("qstnList-outOfSyl21", ['LOGGED']);
    btnMap.set("qstnList-genFeedback", ['LOGGED']);
    btnMap.set("qstnList-askTeacher", ['learner', 'TEACHER', 'PARENT']);
    btnMap.set("qstnList-tagQstn", ['learner', 'TEACHER', 'PARENT']);
    btnMap.set("qstnList-selfNote", ['PVT']);
    btnMap.set("qstnList-writeAns", ['learner']);
    btnMap.set("qstnList-allowEdit", ['crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("qstnList-bookMarker", ['PVT']);
    btnMap.set("qstnList-bookMarker", ['USER', 'learner', 'TEACHER', 'ROLE_COWNER']);
    btnMap.set("qstnList-viewSource", ['TEACHER', 'crclm_mngr']);
    btnMap.set("qstnList-updateQstn", ['crclm_mngr', 'ROLE_ADMIN', 'TEACHER']);
    btnMap.set("qstnList-changeStatus", ['crclm_mngr', 'ROLE_ADMIN', 'TEACHER', 'LWI-STUDENT']);
    btnMap.set("qstnList-updateTag", ['ROLE_ADMIN', 'crclm_mngr']);
    btnMap.set("qstnList-buildFtr", ['TEACHER', 'crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("qstnList-addPBstr", ['TEACHER', 'crclm_mngr', 'ROLE_ADMIN']);


    btnMap.set("cmntList", ['TEACHER', 'crclm_mngr']);
    btnMap.set("cmntList-update", ['crclm_mngr', 'TEACHER', 'ROLE_ADMIN', 'learner']);
    btnMap.set("cmntList-delete", ['ROLE_ADMIN']);
    btnMap.set("cmntList-detail", ['crclm_mngr', 'TEACHER', 'learner', 'ROLE_ADMIN']);
    btnMap.set("cmntList-updateQstn", ['crclm_mngr', 'ROLE_ADMIN']);

    btnMap.set("cmntList-respond", ['crclm_mngr', 'ROLE_ADMIN', 'LWI-TEACHER']);
    btnMap.set("cmntList-resolve", ['crclm_mngr', 'TEACHER', 'LWP-PARENT', 'LWI-TEACHER']);

    btnMap.set("cmntList-crctnBtn", ['crclm_mngr', 'TEACHER', 'LWP-PARENT']);

    btnMap.set("chptrList-changeInactive", ['TEACHER', 'crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("chptrList-outOfSyl21", ['LOGGED']);
    btnMap.set("chptrList-outOfSyl", ['PVT']);
    btnMap.set("chptrList-'showNew'", ['LOGGED']);
    btnMap.set("chptrList-takeTest", ['learner', 'LWI-STUDENT']);
    btnMap.set("chptrList-response", ['crclm_mngr', 'TEACHER']);
    btnMap.set("chptrList-crctn", ['crclm_mngr', 'TEACHER']);
    btnMap.set("chptrList-makeDraft", ['crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("chptrList-showDetail+", ['crclm_mngr', 'ROLE_ADMIN']);
    //btnMap.set("viewList-showDetailAdmin", ['crclm_mngr','ROLE_ADMIN']);
    btnMap.set("chptrList-archiveInput", ['crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("chptrList-validateDraft", ['ROLE_ADMIN', 'TEACHER']);
    btnMap.set("chptrList-finalizeDraft", ['crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("chptrList-loadToDB", ['crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("chptrList-qstnDtl", ['LOGGED']);
    btnMap.set("chptrList-updateHeader", ['crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("chptrList-updateFile", ['crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("chptrList-CRUD", ['crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("chptrList-uploadDoc", ['crclm_mngr', 'TEACHER']);

    btnMap.set("vidBand-", ['crclm_mngr', 'TEACHER']);
    btnMap.set("vidBand-tagHdrList", ['TEACHER', 'crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("vidBand-CRUD", ['crclm_mngr', 'ROLE_ADMIN']);
    btnMap.set("vidBand-twip-dhw", ['ROLE_ADMIN', 'LWI-TEACHER']);
    btnMap.set("vidBand-takeHW", ['ROLE_ADMIN', 'learner']);
    btnMap.set("vidBand-updateQstn", ['crclm_mngr', 'ROLE_ADMIN', 'TEACHER']);

    btnMap.set("vidBand-vid", ['learner', 'LOGGED']);
    btnMap.set("vidBand-tavl-doc", ['learner', 'LOGGED']);
    btnMap.set("vidBand-showTD", ['crclm_mngr', 'ROLE_ADMIN']);

    btnMap.set("vidBand-addVid", ['crclm_mngr', 'ROLE_ADMIN', 'TWI-TEACHER']);

    btnMap.set("textEdtr-allowEdit", ['crclm_mngr', 'ROLE_ADMIN']);
    //console.log(btnMap);
    return btnMap;
  }

  /*
  [
  {"btnId":"outOfSyl","grp":["OWNER","TEACHER"]},
  {"btnId":"outOfSyl","grp":["OWNER","TEACHER"]},
  ] ;
  */

  validBoard(board: string): boolean {
    
    if (this.examList) {
      //  console.log('examList is ', this.examList);
      let exam = this.examList.find(e => e.board === board);
      let valid = exam ? true : false;
      //console.log("Invalid board: "+ board +" ? ,please check supported ExamList"); 
      if (!valid) {
        valid = this.boardList.includes(board);
      }
      return valid;
    }
    else {
      return true;
    }
    /*
    if (this.boardList.includes(board)) {
      return true;
    }
    */
   
  }

  getSiteHead(site: string) {
    var siteHead = "Exam Steppers";
    if (site) {
      if (site == 'esa' || site == 'es') {
        siteHead = "Exam Steppers";
      }
      if (site == 'csa') {
        siteHead = "Career Steppers";
      }

      if (site.startsWith('eb')) {
        siteHead = "Edu Bestu";
      }
    }
  }

  getFeatureHdrId11(site: string, cat: string) {
    return this.getFeatureHdrIdE11(site, cat, 'cmn', 'cmn');
  }

  mapCat(site: string, cat: string) {

    switch (cat) {
      /*
      case "home":{
      
        if(site =='esa'){
         return 'exams';
        }
        return cat;
        break;
        }
    
    */


      /*
      case "te":{
      return 'pbstr';
      break;
      }
      */

      //case "pbs":{return 'alm'; }
      //case "dhs":{return 'alm'; }
      //case "ubs":{return 'alm'; }


      case "fa": {
        return 'car';
        break;
      }

      case "nt": {
        return 'newsinfo';
        break;
      }

      default: {
        return cat;
        break;
      }
    }
  }


  getFeatureHdrIdE11(site: string, cat: string, board: string, course: string) {

    switch (site) {
      case "esa": {

        switch (cat) {
          case 'home': {
            this.headerId = 727;
            break;
          }
          case 'exams': {
            this.headerId = 727;
            break;
          }
          case 'cs': {
            this.headerId = 12;
            break;
          }
          case 'ee': {

            switch (course) {
              case 'XII': {
                this.headerId = 41253;
                break;
              }
              case 'X': {
                this.headerId = 18051;
                break;
              }
              default: {
                this.headerId = 18051;
                break;
              }

                break;
            }
            break;
          }

          case 'sf': {
            this.headerId = 18054;
            break;
          }

          case 'te': {
            this.headerId = 20183;
            break;
          }

          case 'ti': {
            this.headerId = 13;
            break;
          }
          case 'newsinfo': {
            this.headerId = 14;
            break;
          }




          case 'fa': {
            this.headerId = 11;
            break;
          }

          case 'teacher': {
            this.headerId = 17;
            //alert(site +" site&cat from es teacher "  +cat + this.headerId)
            break;
          }


          case 'et': {
            this.headerId = 16;
            //alert(site +" site&cat from et"  +cat + this.headerId)
            break;
          }


          case 'pbstr': {
            this.headerId = 20183;
            break;
          }

          case 'pyq': {
            this.headerId = 679;
            break;
          }

          case 'hwh': {
            this.headerId = 678;
            break;
          }

          case 'car': {
            this.headerId = 11;
            break;
          }
          default: {

            break;
          }
          //20183,33901
        } //switch category

        break;
      } //case  site

      case "eba": {
        switch (cat) {

          case 'ebhome': {
            this.headerId = 21;
            break;
          }

          case 'teacher': {
            this.headerId = 22;
            break;
          }

          case 'parent': {
            this.headerId = 23;
            break;
          }

          case 'institute': {
            this.headerId = 24;
            break;
          }

          case 'learner': {
            this.headerId = 25;
            break;
          }


          default: {
            break;
          }


        }
        break;
      }


    } //switch site
    return this.headerId;
  }


  getList(site: string) {
    /*
    return {"dataList":[{"sequence":"","subSeq":"","part":null,"type":null,"branch":null,"topic":"ICSE-X","book":null,"year":null,"chapterId":null,"section":"","instruction":"","content":"","answer":"","id":11878,"format":"","sctnPart":null,"extLink":"/ICSE/X","title":"ICSE Board Exam","category":"","wireFrame":""},{"sequence":"","subSeq":"","part":null,"type":null,"branch":null,"topic":"CBSE-X","book":null,"year":null,"chapterId":null,"section":"","instruction":"CBSE-starting link","content":"","answer":"","id":11879,"format":"","sctnPart":null,"extLink":"/CBSE/X/","title":"CBSE- X<sup>th</sup> Board","category":"","wireFrame":""},{"sequence":"","subSeq":"","part":null,"type":null,"branch":null,"topic":null,"book":null,"year":null,"chapterId":null,"section":"","instruction":"","content":"","answer":"","id":19951,"format":"","sctnPart":null,"extLink":"/NEET/XI","title":"NEET for Medical-Coming soon","category":"","wireFrame":""}]};
    */
    //console.log("inside fd getList..");
    //return ""
    return {
      "hdrTitle": "Supported Exam/Board-Class List : ",
      "dataList": [{ "extLink": "/CBSE/X/", "title": "CBSE- X<sup>th</sup> Board" },
      { "extLink": "/ICSE/X/", "title": "ICSE - X<sup>th</sup> Board" },
      { "extLink": "/NEET/XI/", "title": "NEET - XI<sup>th</sup> Part" }
      ]
    };
  }

  // 
  clsSecBased(offering: string): boolean {
    var sectionBased: Array<string> = ['tshr-doc', 'tavl-doc', 'tasgn-doc', 'tasgn-pbstr', 'tgubstr', 'tbstr', 'tcrct-tbstr', 'ahw', 'ehw', 'doubt', 'tdhw', 'thw', 'tcrct-thw', 'tasgn-dhw', 'tasgn-tdhw', 'tasgn-dps', 'tps', 'tasgn-eps', 'tcrct-tps', 'trslt-tps', 'trslt-thw', 'trslt-tbstr', 'tclr-hwh', 'tshr-hwh', "mtg"]
    if (offering && offering.includes("tasgn-")) {
      return true;
    }
    return sectionBased.includes(offering)
  }


  getSliderData(site: string) {

    if (site === "esa") {
      return {
        "hdrTitle": "<i>Think Exam Think Steppers</i> ",
        "dataList": [{
          "contentImages": "/examimages/FrontPage/ang/current/es1.jpg",
          "instruction": "Digital Steppers for Exams.",
          "content": "A Truly Digital Learning App for Educational and Competitive Exams...Exam Stepper is about making exam comfortable by leveraging digital steppers. Motivation is better than Fear. Action is better than anxiety.. <br>  As our founder says, all it takes to begin is the first step! Please take first  step and let us overcome fear and anxiety step by step by adopting 'check & Act' as a continuous journey to improve.."
          , "title": "SignUp ...Free for Limited time",
          "extLink": "/features/signup",
          "category": "et"
        },
        {
          "contentImages": "/examimages/FrontPage/ang/current/es2.jpg",
          "instruction": "CBSE & ICSE Students... Hurry Up",
          "content": "Step in to ExamSteppers to Step up the effort for excellent result.</strong> We will handhold you to make you steps as measured and focusess as possible with latest Digital Technologies. After all <strong>Digital Steps at Natural Pace </strong> is our motto..."
          , "title": "Select Board/Exam",
          "extLink": "",
          "category": "exams"
        },
        {
          "contentImages": "/examimages/FrontPage/ang/current/es3.jpg",
          "instruction": "Digital Steppers for Exams.",
          "content": "So Step up and Stay ahead with our innovative properitory Learning tools ....Currently helping our CBSE & ICSE 2020 x<sup>th</sup> Graders  with many features.. <i>Step in to Step up .............Welcome to Exam Steppers!</i>",
          "title": "Select Board/Exam",
          "extLink": "",
          "category": "exams"
        },
        {
          "contentImages": "/examimages/FrontPage/ang/current/es4.jpg",
          "instruction": "Digital Steppers At Natural Pace for Exams.",
          "content": "Welcome to Exam Steppers!</i>",
          "title": "Select Board/Exam",
          "extLink": "",
          "category": "exams"
        }
        ]
      };
    }
    if (site === "eba") {
      return {
        "hdrTitle": "EB the Best:) ",
        "dataList": [{
          "contentImages": "/examimages/FrontPage/ang/current/eb1.jpg",
          "instruction": "Educational Best Digital Platform",
          "content": "The Most sophisticated AI & Analytics powered Educational digital Platform. <br> Powered by Technologist , Driven by Educationist.."
        },
        {
          "contentImages": "/examimages/FrontPage/ang/current/eb2.jpg",
          "instruction": "Stop Settling for Less Than Your Best",
          "content": "For Student: Strive to bring.... Best of YOU! <br>For Teacher:Digital Comfort to impart.... BEST of You!!<br>For Institution: Make Digital so natural.... to facilitate BEST by YOU!!!"
        },
        {
          "contentImages": "/examimages/FrontPage/ang/current/eb3.jpg", "instruction": "Digital Best for Education!!.",
          "content": "Adopt Digital stay ahead and be a becon to Changing AI driven personalized learning!<br> <strong>Welcome to EduBestu. simply the best!!</i>"
        }
        ]
      };
    }

  }
  // http://localhost:8080/rs/s/esa/b/c/pyq/s/contents/27
  getMenuData(site: string) {
    if (site === "esa") {
      return {
        "dataList": [{ "sequence": null, "subSeq": null, "part": null, "type": null, "branch": null, "topic": null, "book": null, "year": null, "chapterId": null, "section": null, "instruction": "Features like Previous Questions, Percentage Booster etc.", "content": null, "answer": null, "id": 41303, "format": null, "sctnPart": null, "extLink": "", "title": "Exam Essentials", "category": "ee", "wireFrame": null }, { "sequence": null, "subSeq": null, "part": null, "type": null, "branch": null, "topic": null, "book": null, "year": null, "chapterId": null, "section": null, "instruction": "Exam Syllabus & Schedule updates etc and popular and right version of Books for purchaes etc.Book ", "content": null, "answer": null, "id": 41304, "format": null, "sctnPart": null, "extLink": "", "title": "Books & Papers", "category": "sf", "wireFrame": null }, { "sequence": null, "subSeq": null, "part": null, "type": null, "branch": null, "topic": null, "book": null, "year": null, "chapterId": null, "section": null, "instruction": "Personalized Test, Check Preparation Level and Act with Timely Booster", "content": null, "answer": null, "id": 41305, "format": null, "sctnPart": null, "extLink": "features/pbstr", "title": "Percentage Booster™", "category": "te", "wireFrame": null }, { "sequence": null, "subSeq": null, "part": "OWNER", "type": null, "branch": null, "topic": null, "book": null, "year": null, "chapterId": null, "section": null, "instruction": "Refreshing story/Video, Thought and Educational News updated daily", "content": null, "answer": null, "id": 41307, "format": null, "sctnPart": null, "extLink": "features/car", "title": "Career Steppers", "category": "fa", "wireFrame": null }, { "sequence": null, "subSeq": null, "part": null, "type": null, "branch": null, "topic": null, "book": null, "year": null, "chapterId": null, "section": null, "instruction": "Fresh & Special", "content": null, "answer": null, "id": 41310, "format": null, "sctnPart": null, "extLink": "features/thought", "title": "Fresh & Special", "category": "ti", "wireFrame": null }, {
          "sequence": null, "subSeq": null, "part": null, "type": null, "branch": null, "topic": null, "book": null, "year": null, "chapterId": null, "section": null, "instruction": "Parents & Teachers", "content": null, "answer": null, "id": 41311, "format": null, "sctnPart": null, "extLink": "features/et",
          "title": " Guardian Engager", "category": "et", "wireFrame": null
        }, { "sequence": null, "subSeq": "NoOfrLst", "part": null, "type": null, "branch": null, "topic": null, "book": null, "year": null, "chapterId": null, "section": null, "instruction": "Contact & Sign Up", "content": null, "answer": null, "id": 41313, "format": null, "sctnPart": null, "extLink": "features/contact", "title": "Engage & Suggest", "category": "cs", "wireFrame": null }]
      }
    }
    if (site === 'eba') {
      return { "dataList": [{ "sequence": null, "subSeq": null, "part": null, "type": null, "branch": null, "topic": null, "book": null, "year": null, "chapterId": null, "section": null, "instruction": "EduBestu", "content": null, "answer": null, "id": 41306, "format": null, "sctnPart": null, "extLink": "features/teacher", "title": null, "category": "ebhome", "wireFrame": null }, { "sequence": null, "subSeq": null, "part": null, "type": null, "branch": null, "topic": null, "book": null, "year": null, "chapterId": null, "section": null, "instruction": "News and Thoughts", "content": null, "answer": null, "id": 41308, "format": null, "sctnPart": null, "extLink": "features/newsinfo", "title": "News & Info", "category": "nt", "wireFrame": null }] }
    }

  }


  getMarketData(site: string) {


    if (site === "esa") {
      return {
        "hdrTitle": "Our Featured Pages:",
        "dataList": [{
          "contentImages": "/examimages/FrontPage/ang/current/Exam Specials.jpg",
          "instruction": "2020 Exam Special",
          "content": "Did you take a note of change in guidelines and specimen in English Language, latest official sample papers released specially for few subjects for ICSE 2019? Know what changes are planned in Mark sheet , latest schedule etc. Common mistakes and exam tips will help you for sure..Look not further... Hurry up to experience yourself please...",
          "extLink": "features/special", "category": "te"
        },
        {
          "contentImages": "/examimages/FrontPage/ang/current/Booster 2.jpg",
          "instruction": "PercentageBooster&trade;",
          "content": "Already completed text books? Don't wonder or wander.. come and take our properitery 'Patented' tool to check your prep. Also we have 51 days capsule of daily booster to make sure 5 questions a day will try to boost your percentage atleast by 5%.. Not convinced yet? ok, Get ready for surprised in time and take a challenge..",
          "extLink": "features/pbstr", "category": "te"
        },
        {
          "contentImages": "/examimages/FrontPage/ang/current/Exam Papers.jpg",
          "instruction": "Previous 10 Years Questions",
          "content": "Looking for Previous 10 Years questions and want to know answers too, also  distracted by answers shown at same place hence not able to practice. Look no further.. our digital platform will help in both practice and learning mode..",
          "extLink": "features/pyq", "category": "ee"
        }
        ]
      };
    }
    if (site === "eba") {
      return {
        "hdrTitle": "Our Features : ",
        "dataList": [{
          "contentImages": "/examimages/FrontPage/ang/current/eb1.jpg",
          "instruction": "Educational Best Digital Platform",
          "content": "The Most sofisticated AI & Analytics powered Educational digital Platform. <br> Powered by Technologist , Driven by Educationist.."
        },
        {
          "contentImages": "/examimages/FrontPage/ang/current/eb2.jpg",
          "instruction": "Stop Settling for Less Than Your Best",
          "content": "For Student: Strive to bring.... Best of YOU! <br>For Teacher:Digital Comfort to impart.... BEST of You!!<br>For Institution: Make Digital so natural.... to facilitate BEST by YOU!!!"
        },
        {
          "contentImages": "/examimages/FrontPage/ang/current/eb3.jpg", "instruction": "Digital Best for Education!!.",
          "content": "Adopt Digital stay ahead and be a becon to Changing AI driven personalized learning!<br> <strong>Welcome to EduBestu. simply the best!!</i>"
        }
        ]
      };
    }

  }


  getUnitTitle(offering: string): string {

    switch (offering) {
      case 'pyq': {
        this.title = "Select Year:";
        break;
      }
      case 'hwh': {
        this.title = "Select Chapter-Section:";
        break;
      }
      default: {
        this.title = "Please Select:";
        break;
      }
    }

    return this.title;
  }

  
  selectQHFlds(offering: string): any {
    var p: any;
    var s: any;

    switch (offering) {
      case 'hwh':
      case 'rbs':
      case 'rba':
        p = ['subject', 'book', 'branch', 'status', 'extUrl'];
        s = ['type', 'hdrFormat', 'upload', 'owner', 'chapterId', 'section', 'title', 'sem', 'headerId', 'cfgFldr'];
        break;

      case 'pyq':
        p = ['subject', 'status', 'extUrl'];
        s = ['type', 'clsSec', 'cfgFldr', 'hdrFormat', 'upload', 'owner', 'year', 'title'];
        break;


      
      case 'doc': {
        p = ['upload', 'uploadTitle', 'subject'];
        s = ['type', 'extUrl', 'clsSec', 'hdrFormat', 'title', 'status'];
        break;
      }

      case 'vid': {
        p = ['title', 'subject'];
        s = ['type', 'headerId', 'sem'];

        break;
      }

      case 'cfg': {

        p = ['title', 'subject', 'summary'];
        s = ['type', 'headerId', 'hdrFormat'];


        break;
      }

      case 'otb': {
        p = ['upload', 'uploadTitle', 'subject'];
        s = ['type', 'extUrl', 'title'];
        break;
      }

      case 'dps':
      case 'pbstr': {
        p = ['title', 'bstrSet', 'summary', 'year', 'sem', 'dueDate', 'testTime'];
        s = ['all'];
        break;
      }

      case 'snote':
      default: {
        p = ['subject', 'title', 'summary'];
        s = ['all'];


        break;
      }
    }
    var d: any = {};
    d.p = p;
    d.s = s;
    return d;
  }


  


  selectQDFlds(offering: string, cat?: string): any {
    var p: any;
    var s: any;

    switch (offering) {
      
      case 'doc': {
        p = ['upload', 'uploadTitle'];
        s = ['section', 'question', 'format'];
        break;
      }

      case 'vid': {
        p = ['vidLink', 'wireframe', 'wireFrame', 'vidInstruction', 'vidMarks'];
        s = ['section', 'headerId', 'upload', 'format'];
        break;
      }

      case 'vidLink': {
        p = ['vidLink', 'vidInstruction', 'vidMarks'];
        s = ['section', 'headerId', 'upload', 'format'];
        break;
      }

      case 'mpb': {
        p = ['wireFrame', 'instruction', 'question', 'answer'];
        s = ['section', 'headerId', 'upload'];
        break;
      }

      case 'cfg': {
        p = ['section', 'groupId', 'category', 'extLink', 'instruction', 'qstnId', 'subqstnId', 'partId', 'questionImages', 'question', 'answerImages', 'answer', 'digInstrctn', 'digQstn', 'title', 'ansrRef'];
        s = ['section', 'headerId', 'status'];
        break;
      }


      case 'sys': {
        p = ['question', 'instruction'];
        s = ['headerId', 'format'];
        break;
      }

      case 'hwh': {
        p = ['instruction', 'question', 'answer', 'digAnsr', 'marks', 'extra'];
        s = ['qstnId', 'subqstnId', 'digInstrctn', 'digQstn', 'digOptns', 'digAnsr', 'status', 'format'];
        break;
      }

      case 'nws': {
        p = ['instruction', 'question', 'answer', 'digAnsr', 'marks', 'extra'];
        s = ['qstnId', 'subqstnId', 'digInstrctn', 'digQstn', 'digOptns', 'digAnsr', 'status', 'format', 'wireframe', 'vidLink', 'wireframe', 'wireFrame'];
        break;
      }

      case 'snote':
      default: {
        p = ['instruction', 'question', 'answer', 'digAnsr', 'marks'];
        s = ['qstnId', 'subqstnId', 'digInstrctn', 'digQstn', 'digOptns', 'digAnsr', 'status', 'format'];
        break;
      }
    }
    var d: any = {};
    d.p = p;
    d.s = s;
    return d;
  }



  selectCmntFlds(fldKey: string): any {
    var p: any;
    var s: any;

    console.log(fldKey);

    switch (fldKey) {
      case 'Hcrct':
      case 'doc': {
        p = ['response', 'marks', 'rspnseUser'];
        s = ['cmntType', 'owner'];
        break;
      }

      case 'rspnd': {
        p = ['response'];
        s = ['cmntType', 'owner', , 'rspnseUser', 'marks'];
        break;
      }


      case 'rspnd-Dclr': {
        p = ['response', 'rspnseUser'];
        s = ['cmntType', 'owner'];
        break;
      }
      case 'crctn': {
        p = ['response', 'marks', 'rspnseUser'];
        s = ['cmntType', 'owner'];
        break;
      }

      default: {
        p = ['comment', 'addUser'];
        s = ['cmntType', 'owner'];
        break;
      }
    }
    var d: any = {};
    d.p = p;
    d.s = s;
    return d;
  }


}


